import { processCourse } from '@api/processors/course';
import { BATCH_GROUPS } from '@cont/EducatorProfile/constants';
import useInfiniteFetch from '@hooks/useInfiniteFetch';
import batchGroup from '@models/BatchGroup';

const defaultLimit = 12;

const processCourseData = (coursesDataFromAPI, isFetching, type) => {
  const newData = coursesDataFromAPI || {};
  newData.results = (newData?.results || []).map((course, index) => {
    // formatting data is if it's batch_group data
    if (type === BATCH_GROUPS) {
      const formattedBatchGroup = batchGroup.getEntityData(course);
      return {
        ...formattedBatchGroup,
        _page: parseInt(index / defaultLimit, 10) + 1,
        _index: index
      };
    }
    return {
      ...processCourse({ ...course, ...(course.programme || {}) }),
      _page: parseInt(index / defaultLimit, 10) + 1,
      _index: index
    };
  });
  newData.isFetching = isFetching;
  return newData;
};

const useCoursesByFilters = (
  { userName, type = '' },
  { filtersApplied, sortsApplied, offset },
  options = { fallbackData: undefined }
) => {
  const filterParams = {
    limit: defaultLimit,
    filters_applied: JSON.stringify(filtersApplied)
  };
  const key = `v1/search_v3/educators/${userName}/courses/v2/`;
  if (sortsApplied) filterParams.sorts_applied = JSON.stringify(sortsApplied);
  if (offset) filterParams.offset = offset;

  const {
    data: coursesByFilters,
    isValidating,
    ...rest
  } = useInfiniteFetch(
    key,
    { applyOffsetsAutomatically: false, params: filterParams },
    {
      persistSize: false,
      fallbackData:
        typeof window === 'undefined' ? options.fallbackData : undefined,
      revalidateOnMount: options.revalidateOnMount,
      revalidateFirstPage: false
    }
  );
  return {
    key,
    isValidating,
    ...rest,
    coursesByFilters: processCourseData(coursesByFilters, isValidating, type)
  };
};

export default useCoursesByFilters;
